import { Stack, Typography } from '@mui/material';
import { PackageCreditItem } from 'components';
import { EmptyUI } from 'components/common';
import ModalUI from 'components/common/ModalUI';
import { ENUM_ORDER_SORT } from 'models';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { getPackageListAction } from 'store/reducers/credits/actionTypes';

interface PopupBuyCreditsProps {
  _onClosePopup: () => void;
}

export function PopupBuyCredits({ _onClosePopup }: PopupBuyCreditsProps) {
  const dispatch = useAppDispatch();
  const { openBuyCredits } = useAppSelector((state) => state.payment);
  const { packageList } = useAppSelector((state) => state.credits);

  useEffect(() => {
    dispatch(
      getPackageListAction({
        data: { sort: `price-${ENUM_ORDER_SORT.ASC}` },
      }),
    );
  }, [dispatch]);

  if (!packageList) return;
  return (
    <ModalUI open={openBuyCredits} maxW={900} onClose={_onClosePopup}>
      <Stack spacing={1} alignItems="center" pb={4}>
        <Typography variant="Web_Title_22">Buy Credits</Typography>
        <Typography variant="Web_Label_18">
          Select a Sitter Plan to purchase
        </Typography>
      </Stack>
      <Stack width={'90%'} margin={'auto'}>
        <Stack
          flexDirection={'row'}
          alignItems="center"
          justifyContent="center"
          flexWrap={{ xs: 'wrap', md: 'nowrap' }}
          sx={{ gap: 1 }}
        >
          {packageList.length > 0 ? (
            packageList.map((item) => (
              <PackageCreditItem key={item.id} data={item} isPayWithCredit />
            ))
          ) : (
            <EmptyUI content="There are no packages available" />
          )}
        </Stack>
      </Stack>
    </ModalUI>
  );
}

export default PopupBuyCredits;
